<button
    type="button"
    class="cmps-cdk-bg-color-black cmps-cdk-border-width-0p cmps-cdk-color-white cmps-cdk-h-40px cmps-cdk-py-0 cmps-cdk-px-0dot5 cmps-cdk-w-120px cmps-cdk-text-left cmps-cdk-cursor-pointer cmps-cdk-align-items-center cmps-cdk-cg-0dot5 cmps-cdk-d-flex focus:not:focus-visible:cmps-cdk-outline-none"
    [cmpsOverlayTrigger]="langTpl"
>
    <cmps-icon
        class="cmps-cdk-fill-grey-400"
        svgIcon="web"
    ></cmps-icon>
    <span class="cmps-cdk-flex-grow-1">{{ _currentLocale }}</span>
    <cmps-icon
        class="cmps-cdk-fill-grey-400"
        [svgIcon]="_pending ? 'progress-helper' : 'chevron-right'"
    ></cmps-icon>
</button>

<ng-template
    let-overlay="overlay"
    #langTpl
>
    <div class="cmps-cdk-d-flex cmps-cdk-flex-column">
        <div
            class="cmps-cdk-mt-0dot25"
            *ngFor="let i of _languages"
        >
            <button
                type="button"
                class="cmps-cdk-bg-color-black cmps-cdk-border-width-0p cmps-cdk-color-white cmps-cdk-h-40px cmps-cdk-py-0 cmps-cdk-px-0dot5 cmps-cdk-w-120px cmps-cdk-text-left cmps-cdk-cursor-pointer cmps-cdk-align-items-center cmps-cdk-cg-0dot5 cmps-cdk-d-flex focus:not:focus-visible:cmps-cdk-outline-none"
                (click)="overlay.close(); _onLanguageSelect(i)"
            >
                <cmps-icon
                    class="cmps-cdk-fill-grey-400"
                    svgIcon="web"
                ></cmps-icon>
                <span>{{ i.initial }}</span>
            </button>
        </div>
    </div>
</ng-template>
